import { headerPadding } from "configs/general";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

const LogoContainer = styled.div`
  z-index: 1;
  padding-top: ${headerPadding.top.xl};
  padding-left: 100px;
  padding-bottom: 20px;

  @media (max-width: ${breakpoints.lg}) {
    padding-left: ${headerPadding.horizontal.lg};
  }

  @media (max-width: ${breakpoints.md}) {
    padding-top: ${headerPadding.top.md};
  }

  @media (max-width: ${breakpoints.sm}) {
    padding-left: ${headerPadding.horizontal.sm};
  }
`;

export default LogoContainer;
